import React, { useEffect, useRef, useState } from 'react';
import '../../styles/components/profile_page/AlbumsSideBar.css';

const Kebab = ({ onRename, onDelete }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const handleKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', handleDown);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleDown);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);

  return (
    <div ref={ref} className="albumsSidebar__kebab" onClick={(e)=>e.stopPropagation()}>
      <button
        className="kebabBtn"
        onClick={() => setOpen(o => !o)}
        aria-label="Album actions"
        aria-expanded={open}
      >
        ⋯
      </button>
      {open && (
        <div className="kebabMenu" role="menu">
          <button role="menuitem" onClick={onRename}>Rename</button>
          <button role="menuitem" className="danger" onClick={onDelete}>Delete</button>
        </div>
      )}
    </div>
  );
};

const AlbumsSideBar = ({
  albums,
  current,
  onSelect,
  isOwner,
  showCreate = false,     // default off; we use header +Album
  onCreate,
  onRename,
  onDelete,
  onDropOnAlbum,
}) => {
  const albumNames = Object.keys(albums);

  return (
    <aside className="albumsSidebar">
      <div className="albumsSidebar__header">
        <h3>Albums</h3>
        {isOwner && showCreate && (
          <button className="albumsSidebar__new" onClick={onCreate}>+ New</button>
        )}
      </div>

      <ul className="albumsSidebar__list">
        {albumNames.map((name) => {
          const list = albums[name] || [];
          const cover = list[0]?.url || list[0]?.s3_url;
          const isActive = name === current;

          return (
            <li
              key={name}
              className={`albumsSidebar__item ${isActive ? 'is-active' : ''}`}
              onClick={() => onSelect?.(name)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                const data = e.dataTransfer.getData('text/json');
                if (!data) return;
                try {
                  const { photoIds } = JSON.parse(data);
                  onDropOnAlbum?.(name, photoIds);
                } catch {}
              }}
            >
              <div className="albumsSidebar__thumb" style={{ backgroundImage: cover ? `url(${cover})` : 'none' }} />
              <div className="albumsSidebar__meta">
                <div className="albumsSidebar__name">{name}</div>
                <div className="albumsSidebar__count">{list.length}</div>
              </div>
              {isOwner && (
                <Kebab
                  onRename={() => onRename?.(name)}
                  onDelete={() => onDelete?.(name)}
                />
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default AlbumsSideBar;
